import {
  OpenAPI,
  TfaVerificationRequest,
  TwoFactorAuthenticationService,
} from '@api'
import { useMutation } from 'react-query'

import { useAccount } from '@/modules/accounts/hooks/useAccounts.ts'

export function useAuthenticateTfa() {
  const account = useAccount()

  return useMutation(
    'tfa-authenticate',
    (values: TfaVerificationRequest) => {
      const token = OpenAPI.TOKEN

      OpenAPI.HEADERS = { Authorization: '' }
      OpenAPI.TOKEN = ''
      const promise = TwoFactorAuthenticationService.tfAuthenticate({
        requestBody: values,
      })

      OpenAPI.TOKEN = token
      OpenAPI.HEADERS = undefined

      return promise
    },
    {
      onSuccess: () => {
        account.setAsLoggedIn()
      },
    },
  )
}
